import React, { useEffect } from "react";
import './board.css'
import Aos from "aos";
import "aos/dist/aos.css";

const profiles = [
  {
    name: "M. A. S. Rahuman",
    projects: "Managing Director",
    description:
      "Supply Chain(ISMM) & HR Management Admin & Finance",
    imgSrc:
      "https://eu.ui-avatars.com/api/?name=Sohn+Roe&size=250",
    fb: "https://www.facebook.com/profile.php?id=61573453107657&sk=friends"
  },
  {
    name: "W. A. W. Niroshan",
    projects: "Managing Director",
    description:
      "Business R&D and Marketing HR Consultant",
    imgSrc:
      "https://eu.ui-avatars.com/api/?name=Wohn+Noe&size=250",
  },
  {
    name: "Deepal Wanninayake",
    projects: "Sales Manager",
    description:
      "Sales Manager",
    imgSrc:
      "https://eu.ui-avatars.com/api/?name=Dohn+Woe&size=250",
  },
  // {
  //   name: "Taylor Green",
  //   projects: "Position name",
  //   description:
  //     "We will add the real image, position and description..",
  //   imgSrc:
  //     "https://eu.ui-avatars.com/api/?name=Tohn+Goe&size=250",
  // },
  // {
  //   name: "Isaiah Jian",
  //   projects: "Position name",
  //   description:
  //     "We will add the real image, position and description.",
  //   imgSrc:
  //     "https://eu.ui-avatars.com/api/?name=Iohn+Joe&size=250",
  // },
];

const ProfileCard = ({ name, projects, description, imgSrc, fb }) => {
  return (
    <div className="box board">
      <div className="box-top">
        <img className="box-image" src={imgSrc} alt={name} />
        <div className="title-flex">
          <h3 className="box-title">{name}</h3>
          <p className="user-follow-info p">{projects}</p>
        </div>
        <p className="description p">{description}</p>
      </div>
      <a href={fb} className="button a">
        Follow on Facebook
      </a>
    </div>
  );
};

const Board = () => {

    useEffect(() => {
        Aos.init({ duration: 2000 });
    }, []);

  return (
    <div className="body">
        <div
            className="clientReview-title"
            data-aos="fade-down"
            data-aos-duration="700"
          >
            <h1 className="clientReview-title-h1">Our Board Members</h1>
        </div>
        <div className="wrap board">
            {profiles.map((profile, index) => (
                <ProfileCard key={index} {...profile} />
            ))}
        </div>
    </div>
  );
};

export default Board;
